module.exports = __webpack_public_path__ + "img/language-icon.b0a26e08.svg";